import { render, staticRenderFns } from "./Servicio.vue?vue&type=template&id=1a70b9ba&scoped=true&"
import script from "./Servicio.vue?vue&type=script&lang=js&"
export * from "./Servicio.vue?vue&type=script&lang=js&"
import style0 from "./Servicio.vue?vue&type=style&index=0&id=1a70b9ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a70b9ba",
  null
  
)

export default component.exports